import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import DataTable from '../../components/Table/DataTable';
import SearchBox from './../../components/SearchBox/SearchBox';

import { getChannels } from '../../services/channel';
import { showAlert } from '../../store/ducks/alert';

import { CircularProgress, Button } from '@material-ui/core';

const Channels = ({ location, match }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [channels, setChannels] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [isOrdering, setIsOrdering] = useState(0);
  const [searchField, setSearchField] = useState({
    searchItem: '',
    search: '',
  });
  const [orderDirections, setOrderDirections] = useState({
    item: '',
    direction: '',
  });
  useEffect(() => {
    if (location.state && location.state.remount) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
    }
  }, [location]);

  useEffect(() => {
    let currentPage = location.search.split('=')[1] || page;
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchItem,
        search: match.params.search,
      });
    }
    displayChannels(currentPage);
  }, [isSearching, isOrdering, page]);

  const handleSubmitSearch = searchBox => {
    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(searchBox.search);
  };

  const headers = ['id', 'userId', 'name', 'isEnabled', 'isPublic', 'hasPaymentIntegration', 'updatedAt'];

  const SearchBoxHeaders = ['id', 'uid', 'userId', 'name', 'email', 'slug'];

  const displayChannels = async currentPage => {
    try {
      setIsLoading(true);

      let params = { order: orderDirections.item, direction: orderDirections.direction, limit: 5 };
      if (isSearching) params = { ...searchField, ...params };
      const { data: channels } = await getChannels(currentPage || page, params);

      setChannels(channels.rows);
      setTotalItems(channels.count);
      setTotalPages(channels.pages);
      setPage(channels.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };

  const handleGoToWithoutAddress = () => {
    history.push(`/channels/withoutAddress`);
  };

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container" data-testid="channels-container">
        <h1>Channels ({totalItems})</h1>
        <Button data-testid="channels-btn-address" onClick={handleGoToWithoutAddress} variant="contained" className="modal-btn">
          Channels Without Address
        </Button>
        <SearchBox
          selectItems={SearchBoxHeaders}
          onSubmitSearch={handleSubmitSearch}
          isSearching={isSearching}
          setIsOrdering={setIsOrdering}
        />
      </div>

      <DataTable
        useUid={true}
        head={headers}
        body={channels}
        action={true}
        bodyColumn={headers}
        linkPath={'channels'}
        totalPages={totalPages}
        currentPage={page}
        orderDirections={orderDirections}
        setOrderDirections={setOrderDirections}
        setPageChange={setPage}
        setIsOrdering={setIsOrdering}
        isOrdering={isOrdering}
      />
    </>
  );
};

export default Channels;
